import $http from '../../shared/http';
import i18next from 'i18next';

export const organisation_tasks = {
  namespaced: true,
  state: () => {
    return {
      existenceDataLoaded: false,
      firstCreations: {
        firstMember: false,
        firstService: false,
        firstVisitor: false,
        firstServiceActivitiesTemplate: false,
      },
    };
  },
  getters: {
    getExistenceDataLoaded: (state) => state.existenceDataLoaded,
    getFirstCreations: (state) => state.firstCreations,
    tasks: (state, getters, rootState, rootGetters) => () => {
      return {
        [i18next.t('organisation_tasks.complete_onboarding_stage_one', { ns: 'general' })]: {
          weight: 0.4,
          done: !rootGetters['onboardings/isOnboardingNotCompleted'],
        },
        [i18next.t('organisation_tasks.create_first_member', { ns: 'general' })]: {
          weight: 0.15,
          done: getters['getFirstCreations'].firstMember,
        },
        [i18next.t('organisation_tasks.create_first_visitor', { ns: 'general' })]: {
          weight: 0.15,
          done: getters['getFirstCreations'].firstVisitor,
        },
        [i18next.t('organisation_tasks.create_first_service', { ns: 'general' })]: {
          weight: 0.15,
          done: getters['getFirstCreations'].firstService,
        },
        [i18next.t('organisation_tasks.create_first_service_activities_template', {
          ns: 'general',
        })]: {
          weight: 0.15,
          done: getters['getFirstCreations'].firstServiceActivitiesTemplate,
        },
      };
    },
    getTasks: (state, getters) => () => getters.tasks(),
    getTasksValues: (state, getters) => {
      return Object.values(getters.getTasks());
    },
    getTasksKeys: (state, getters) => {
      return Object.keys(getters.getTasks());
    },
    getUndoneTasksValues: (state, getters) => {
      return getters.getTasksValues.filter((task) => {
        return !task.done;
      });
    },
    getDoneTasks: (state, getters) => () => {
      return Object.entries(getters.getTasks()).filter(([, value]) => {
        return value.done;
      });
    },
    getDoneTasksKeys: (state, getters) => () => {
      return getters.getDoneTasks().map(([key]) => key);
    },
    getDoneTasksValues: (state, getters) => {
      return getters.getDoneTasks().map(([, value]) => value);
    },
    getUndoneTasksCount: (state, getters) => {
      return getters.getUndoneTasksValues.length;
    },
    getDoneTasksCount: (state, getters) => {
      return getters.getDoneTasks().length;
    },
    getUndoneTasksKeys: (state, getters) => {
      return getters.getTasksKeys.filter((key) => {
        return !getters.getTasks()[key].done;
      });
    },
    getDonePercentage: (state, getters) => {
      return getters.getDoneTasksValues.length
        ? getters.getDoneTasksValues.reduce((acc, curTask) => curTask.weight + acc, 0) * 100
        : 0;
    },
  },
  mutations: {
    setExistenceDataLoaded: (state, payload) => (state.existenceDataLoaded = payload),
    setFirstCreations: (state, payload) => (state.firstCreations = payload),
  },
  actions: {
    async CHECK_FIRST_CREATIONS({ commit }, { churchId }) {
      return $http()
        .get(`/organisations/${churchId}/organisation-tasks/first-creations`, {
          canBeImpersonated: true,
        })
        .then((response) => {
          commit('setFirstCreations', response.data.data);
          return response;
        });
    },
  },
};
